import Navbar from "../../components/app/Navbar";
// import Map from "../../components/app/Map";
import map from "../../assets/map.png";
import cardYellow from "../../assets/card-yellow.png";
import cardGreen from "../../assets/card-green.png";
import { Link } from "react-router-dom";

export default function Dashboard() {
  return (
    <div>
      <div>
        <Navbar />
      </div>
      <div className="lg:grid grid-cols-3 gap-5 px-4 lg:px-16 py-14">
        <div className="border h-fit border-border rounded-lg col-span-1">
          <div className="p-7 border-b border-border">
            <h1 className="font-semibold text-xl">Select a service</h1>
          </div>
          <div className="p-3 space-y-7 my-5">
            <div
              style={{ backgroundImage: `url(${cardYellow})` }}
              className="bg-cover bg-center p-3 rounded-xl"
            >
              <Link to="/send-package">
                <h1 className="font-semibold text-lg">Send a package</h1>
                <p className="font-medium text-paragraph mt-1">
                  ZAP makes it easy to send packages of all sizes, with our fast
                  and reliable delivery services.
                </p>
              </Link>
            </div>
            <div
              style={{ backgroundImage: `url(${cardGreen})` }}
              className="bg-cover p-3 rounded-xl"
            >
              <h1 className="font-semibold text-lg">Receive a package</h1>
              <p className="font-medium text-paragraph mt-1">
                ZAP makes it easy to receive packages of all sizes, with our
                fast and reliable delivery services.
              </p>
            </div>
          </div>
        </div>
        <div className="col-span-2 max-lg:hidden">
          <img src={map} alt="" />
        </div>
      </div>
    </div>
  );
}
